import { Injectable } from '@angular/core';
import { UrlConnectionEnum } from 'src/app/enums/connection/url-connection.enum';
import { HttpService } from '../http-service/http.service';
import { lastValueFrom } from 'rxjs';
@Injectable({
    providedIn: 'root'
})
export class ResetPwdService {

    constructor(private httpService: HttpService) { }

    /**
     * Rests pwd
     * @author Starley Cazorla
     * @param cpf
     * @returns
     */
    async restPwd(cpf: string) {
        let config = this.httpService.setHeaderConfig(false)
        return lastValueFrom(this.httpService.post(UrlConnectionEnum.RESET_PWD, { cpf }, config));
    }

}
